var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41946 6.00254L7.00431 1.51317C7.13055 1.38985 7.2 1.22498 7.2 1.04917C7.2 0.873268 7.13055 0.708488 7.00431 0.584976L6.60256 0.191805C6.47651 0.0680976 6.30802 0 6.12847 0C5.94892 0 5.78063 0.0680976 5.65448 0.191805L0.195497 5.53678C0.068854 5.66068 -0.000495531 5.82624 2.66949e-06 6.00224C-0.000495531 6.17902 0.0687544 6.34439 0.195497 6.46839L5.6494 11.8082C5.77554 11.9319 5.94384 12 6.12349 12C6.30304 12 6.47133 11.9319 6.59758 11.8082L6.99923 11.415C7.26058 11.1591 7.26058 10.7425 6.99923 10.4867L2.41946 6.00254Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.0e56f7cdb126e45152f3c60b75976dfc.svg";
export { ForwardRef as ReactComponent };